module.exports = __webpack_public_path__ + "img/green_008.f6225f68.png";